'use client';
import { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

export default function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      position="bottom-left"
      toastOptions={{
        unstyled: true,
        closeButton: true,
        classNames: {
          toast:
            'w-[18.75rem] rounded-5 p-5 flex gap-x-4 overflow-hidden shadow-base-achromatic bg-white after:absolute after:top-0 after:h-1',
          icon: 'w-8 h-8 mx-0',
          title: 'text-[1rem] leading-[1.5] font-bold',
          description: 'text-achromatic-light text-[0.875rem] leading-[1.75]',
        },
      }}
      {...props}
    />
  );
}
